export const data = {
  logbookName: "Groups Demo 1",
  logbookVersion: "1.0.0",
  primaryVerifiers: [],
  secondaryVerifiers: [],
  regulatory: 0,
  author: "",
  features: {
    panel: {
      align: "left",
    },
  },
  content: [
    {
      group: "ENG",
      layout: "horizontal",
      panel: "ID1",
      label: {
        text: "MAIN",
        textAlign: "center",
        bold: true,
        padding: "12px",
        orientation: "top",
        style: "solid",
      },
      content: [
        {
          group: "ENG",
          layout: "horizontal",
          panel: "ID2",
          label: {
            text: "SECTION 1",
            textAlign: "center",
            padding: "6px",
            orientation: "top",
            style: "solid",
          },
          content: [
            {
              group: "ENG",
              layout: "vertical",
              panel: "A1",
              label: {
                text: "LIST A",
                textAlign: "center",
                padding: "6px",
                orientation: "top",
                style: "solid",
              },
              inherited: {
                label: {
                  orientation: "left",
                  textAlign: "left",
                  width: "25%",
                },
                unit: {
                  width: "54px",
                  style: "inset-solid",
                },
              },
              content: [
                {
                  item: "1",
                  label: {
                    text: "Col A1",
                  },
                  component: "text",
                  unit: {
                    text: "L/H",
                  },
                },
                {
                  item: "1",
                  label: {
                    text: "Col A2",
                  },
                  component: "text",
                  unit: {
                    text: "L/H",
                  },
                },
                {
                  item: "1",
                  label: {
                    text: "Col A3",
                  },
                  component: "text",
                  unit: {
                    text: "L/H",
                  },
                },
              ],
            },
            {
              group: "ENG",
              layout: "vertical",
              panel: "A2",
              label: {
                text: "LIST B",
                textAlign: "center",
                padding: "6px",
                orientation: "top",
                style: "solid",
              },
              inherited: {
                label: {
                  orientation: "left",
                  textAlign: "left",
                  width: "35%",
                },
                unit: {
                  width: "54px",
                  style: "inset-solid",
                },
              },
              content: [
                {
                  item: "1",
                  label: {
                    text: "Col B1",
                  },
                  component: "text",
                  unit: {
                    text: "L/H",
                  },
                },
                {
                  item: "1",
                  label: {
                    text: "Col B2",
                  },
                  component: "text",
                  unit: {
                    text: "L/H",
                  },
                },
                {
                  item: "1",
                  label: {
                    text: "Col B3",
                  },
                  component: "text",
                  unit: {
                    text: "L/H",
                  },
                },
              ],
            },
            {
              group: "ENG",
              layout: "vertical",
              panel: "A3",
              label: {
                text: "LIST C",
                textAlign: "center",
                padding: "6px",
                orientation: "top",
                style: "solid",
              },
              inherited: {
                label: {
                  orientation: "left",
                  textAlign: "left",
                  width: "35%",
                },
                unit: {
                  width: "54px",
                  style: "inset-solid",
                },
              },
              content: [
                {
                  item: "1",
                  label: {
                    text: "Col C1",
                  },
                  component: "text",
                  unit: {
                    text: "L/H",
                  },
                },
                {
                  item: "1",
                  label: {
                    text: "Col C2",
                  },
                  component: "text",
                  unit: {
                    text: "L/H",
                  },
                },
                {
                  item: "1",
                  label: {
                    text: "Col C3",
                  },
                  component: "text",
                  unit: {
                    text: "L/H",
                  },
                },
              ],
            },
            {
              group: "ENG",
              layout: "vertical",
              width: "400%",
              panel: "ID3",
              label: {
                text: "SECTION 2",
                textAlign: "center",
                padding: "6px",
                orientation: "top",
                style: "solid",
              },
              content: [
                {
                  group: "ENG",
                  layout: "horizontal",
                  panel: "D1",
                  label: {
                    text: "Description Here",
                    textAlign: "center",
                    padding: "6px",
                    orientation: "top",
                  },
                  inherited: {
                    label: {
                      orientation: "left",
                      textAlign: "left",
                      width: "25%",
                    },
                    text: {
                      width: "100%",
                    },
                    unit: {
                      width: "54px",
                      style: "inset-solid",
                    },
                  },
                  content: [
                    {
                      item: "1",
                      label: {
                        text: "Col D1",
                      },
                      component: "text",
                      unit: {
                        text: "L/H",
                      },
                    },
                    {
                      item: "1",
                      label: {
                        text: "Col D2",
                      },
                      component: "text",
                      unit: {
                        text: "L/H",
                      },
                    },
                  ],
                },
                {
                  group: "ENG",
                  layout: "horizontal",
                  panel: "W1",
                  label: {
                    text: "WIDE 1",
                    textAlign: "center",
                    padding: "6px",
                    orientation: "top",
                    style: "solid",
                  },
                  inherited: {
                    label: {
                      orientation: "left",
                      textAlign: "left",
                      width: "25%",
                    },
                    text: {
                      width: "100%",
                    },
                    unit: {
                      width: "54px",
                      style: "inset-solid",
                    },
                  },
                  content: [
                    {
                      item: "1",
                      label: {
                        text: "Col D1",
                      },
                      component: "text",
                      unit: {
                        text: "L/H",
                      },
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
    {
      group: "ENG",
      layout: "vertical",
      panel: "SUB4",
      marginTop: "24px",
      label: {
        text: "EXTRA 1",
        textAlign: "center",
        padding: "6px",
        bold: true,
        orientation: "top",
        style: "solid",
      },
      content: [
        {
          group: "ENG",
          layout: "horizontal",
          panel: "SUB4D1",
          label: {
            text: "LIST D",
            textAlign: "center",
            padding: "6px",
            orientation: "top",
            style: "solid",
          },
          inherited: {
            label: {
              orientation: "left",
              textAlign: "left",
              width: "25%",
            },
            text: {
              width: "100%",
            },
            unit: {
              width: "54px",
              style: "inset-solid",
            },
          },
          content: [
            {
              item: "1",
              label: {
                text: "Col D1",
              },
              component: "text",
              unit: {
                text: "L/H",
              },
            },
            {
              item: "1",
              label: {
                text: "Col D2",
              },
              component: "text",
              unit: {
                text: "L/H",
              },
            },
          ],
        },
        {
          group: "ENG",
          layout: "horizontal",
          panel: "SUB4D2",
          label: {
            text: "WIDE 1",
            textAlign: "center",
            padding: "6px",
            orientation: "top",
            style: "solid",
          },
          inherited: {
            label: {
              orientation: "left",
              textAlign: "left",
              width: "25%",
            },
            text: {
              width: "100%",
            },
            unit: {
              width: "54px",
              style: "inset-solid",
            },
          },
          content: [
            {
              item: "1",
              label: {
                text: "Col D1",
              },
              component: "text",
              unit: {
                text: "L/H",
              },
            },
          ],
        },
      ],
    },
  ],
};
